/* Empyreum TOC enhancement. Native gallery, cart and variant code is not replaced. */
(function () {
  'use strict';
  if (window.EmpyreumProductV3) { window.EmpyreumProductV3.init(document); return; }
  const ready = new WeakSet();
  const observers = new WeakMap();
  function legacyList(root, target) {
    const description = root.querySelector('[data-emp-description]');
    if (!description || !target) return;
    const heading = Array.from(description.querySelectorAll('h2,h3,h4,h5,p')).find(node => {
      if (node.closest('li,blockquote')) return false;
      return /^(tartalom|tartalomjegyz\u00e9k):?$/.test(node.textContent.trim().toLocaleLowerCase('hu-HU'));
    });
    if (!heading) return;
    let next = heading.nextElementSibling, list = null, wrapper = null;
    const spacers = [];
    for (let i = 0; i < 4 && next; i++) {
      if (/^(UL|OL)$/.test(next.tagName)) { list = next; break; }
      if (next.tagName === 'DIV' && next.children.length === 1 && /^(UL|OL)$/.test(next.firstElementChild.tagName)) { wrapper = next; list = next.firstElementChild; break; }
      if (next.tagName !== 'HR' && !(next.tagName === 'P' && !next.textContent.trim())) break;
      spacers.push(next); next = next.nextElementSibling;
    }
    if (!list) return;
    const previous = heading.previousElementSibling;
    if (target.querySelector('[data-emp-chapters] > li')) list.remove();
    else target.appendChild(list);
    if (wrapper && !wrapper.textContent.trim()) wrapper.remove();
    heading.remove(); spacers.forEach(el => el.remove());
    if (previous && (previous.tagName === 'HR' || (previous.tagName === 'P' && /^[-_\u2013\u2014\s]{3,}$/.test(previous.textContent)))) previous.remove();
    if (!description.textContent.trim() && !description.querySelector('img,video,iframe')) description.closest('.emp-story').hidden = true;
  }
  function setup(root) {
    if (ready.has(root)) return;
    ready.add(root);
    root.querySelectorAll('.product-thumbnail').forEach((thumb, index) => {
      thumb.tabIndex = 0;
      thumb.setAttribute('role', 'button');
      thumb.setAttribute('aria-label', 'Termékkép ' + (index + 1) + ' megnyitása');
      thumb.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); thumb.click(); } });
    });
    const panel = root.querySelector('[data-emp-contents]');
    const body = root.querySelector('[data-emp-contents-body]');
    if (!panel || !body) return;
    legacyList(root, body);
    const list = body.querySelector('ol,ul');
    if (!list) return;
    const items = Array.from(list.children).filter(el => el.tagName === 'LI' && el.textContent.trim());
    if (!items.length) { panel.hidden = true; return; }
    list.classList.add('emp-chapters'); list.setAttribute('role','list');
    list.querySelectorAll('li,ul,ol').forEach(el => el.removeAttribute('style'));
    list.removeAttribute('style');
    list.id = 'EmpChapters-' + root.dataset.sectionId;
    const total = panel.querySelector('[data-emp-total]');
    if (total) total.textContent = items.length + ' fejezet';
    panel.hidden = false;
    const nav = panel.querySelector('[data-emp-pages]');
    const prev = panel.querySelector('[data-emp-prev]');
    const next = panel.querySelector('[data-emp-next]');
    const status = panel.querySelector('[data-emp-status]');
    if (!nav || !prev || !next || !status || items.length <= 10) return;
    const pages = Math.ceil(items.length / 10);
    let page = 0;
    function render() {
      const first = page * 10;
      items.forEach((el, index) => { el.hidden = index < first || index >= first + 10; });
      prev.disabled = page === 0; next.disabled = page === pages - 1;
      status.textContent = (page + 1) + ' / ' + pages + ' oldal';
    }
    prev.addEventListener('click', () => { if (page > 0) { page--; render(); if (prev.disabled) next.focus({preventScroll:true}); } });
    next.addEventListener('click', () => { if (page < pages - 1) { page++; render(); if (next.disabled) prev.focus({preventScroll:true}); } });
    nav.hidden = false; render();
    // Reserve the tallest ten-entry page, including wrapped titles. No text is clipped.
    let measuredWidth = 0, frame = 0;
    function reserveHeight() {
      const width = body.getBoundingClientRect().width;
      if (width < 1 || Math.abs(width - measuredWidth) < 1) return;
      measuredWidth = width;
      const state = items.map(el => el.hidden);
      items.forEach(el => { el.hidden = false; });
      const heights = items.map(el => el.getBoundingClientRect().height);
      let maximum = 0;
      for (let i = 0; i < heights.length; i += 10) maximum = Math.max(maximum, heights.slice(i, i + 10).reduce((sum, h) => sum + h, 0));
      body.style.minHeight = Math.ceil(maximum) + 'px';
      items.forEach((el, i) => { el.hidden = state[i]; });
    }
    reserveHeight();
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(() => { cancelAnimationFrame(frame); frame = requestAnimationFrame(reserveHeight); });
      observer.observe(body);
      observers.set(root, () => { observer.disconnect(); cancelAnimationFrame(frame); });
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { measuredWidth = 0; reserveHeight(); });
  }
  function init(context) {
    if (context.matches && context.matches('[data-emp-product]')) setup(context);
    context.querySelectorAll('[data-emp-product]').forEach(setup);
  }
  document.addEventListener('product:variant-change', event => {
    const detail = event.detail || {};
    document.querySelectorAll('[data-emp-product]').forEach(root => {
      if (String(detail.sectionId) !== root.dataset.sectionId || !detail.variant) return;
      const data = root.querySelector('[data-emp-variant-facts]');
      if (!data) return;
      try {
        const row = JSON.parse(data.textContent)[String(detail.variant.id)];
        if (!row) return;
        const sku = root.querySelector('[data-emp-sku]'), weight = root.querySelector('[data-emp-weight]');
        if (sku) { sku.textContent = row.sku || ''; sku.closest('.emp-fact').hidden = !row.sku; }
        if (weight) { weight.textContent = row.weight || ''; weight.closest('.emp-fact').hidden = !row.has_weight; }
      } catch (error) { /* A malformed optional metadata payload must not interrupt the cart. */ }
    });
  });
  window.EmpyreumProductV3 = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => { event.target.querySelectorAll('[data-emp-product]').forEach(root => { const cleanup = observers.get(root); if (cleanup) cleanup(); }); });
})();

/* Notify Me! integration: remove the redundant sold-out CTA only after the
   app's real inline button is visible. Never clone it, replace its contents,
   change variant IDs, or bypass the native cart's disabled state.
   Button wording remains editable in Notify Me! > Back in Stock > Buttons. */
(function () {
  'use strict';
  if (window.EmpyreumPurchaseControls) { window.EmpyreumPurchaseControls.init(document); return; }
  const controllers = new Map();
  const appSelector = '.restock-alerts-notify-button, .PRODUCT_PAGE-notify-button';
  const normalize = value => String(value || '').replace(/\s+/g, ' ').trim().toLocaleLowerCase('hu-HU');

  function isVisibleAction(element, region) {
    if (!element || !element.isConnected || element.matches(':disabled,[aria-disabled="true"]')) return false;
    if (element.closest('dialog,[role="dialog"],.restock-alerts-modal-wrapper,[hidden],[inert],[aria-hidden="true"]')) return false;
    if (!element.getClientRects().length) return false;
    const rect = element.getBoundingClientRect();
    if (rect.width < 1 || rect.height < 1) return false;
    for (let node = element; node && region.contains(node); node = node.parentElement) {
      const style = getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || Number(style.opacity) === 0 || style.position === 'fixed') return false;
    }
    return true;
  }

  function setup(root) {
    if (controllers.has(root)) return;
    const region = root.querySelector('.product-information');
    if (!region || !window.MutationObserver) return;
    let frame = 0;
    function update() {
      frame = 0;
      if (!root.isConnected) { dispose(root); return; }
      const soldOut = normalize(window.theme && window.theme.variantStrings && window.theme.variantStrings.soldOut || 'Elfogyott');
      const actions = Array.from(region.querySelectorAll(appSelector)).map(node => {
        return node.matches('button,a,[role="button"]') ? node : node.querySelector('button,a,[role="button"]');
      }).filter(Boolean);
      const appButton = actions.find(node => isVisibleAction(node, region));
      let replaced = false;
      region.querySelectorAll('.single-add-to-cart-button').forEach(button => {
        const label = button.querySelector('.single-add-to-cart-button--text');
        const redundant = !!appButton && button.disabled && !!label && normalize(label.textContent) === soldOut;
        button.toggleAttribute('data-emp-notify-replaced', redundant);
        replaced = replaced || redundant;
      });
      region.querySelectorAll('[data-emp-notify-primary]').forEach(button => {
        if (!replaced || button !== appButton) button.removeAttribute('data-emp-notify-primary');
      });
      if (replaced && !appButton.hasAttribute('data-emp-notify-primary')) appButton.setAttribute('data-emp-notify-primary', '');
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(update); }
    const observer = new MutationObserver(schedule);
    observer.observe(region, {
      childList: true, subtree: true, characterData: true, attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'inert', 'disabled', 'aria-disabled', 'aria-hidden']
    });
    region.addEventListener('change', schedule);
    region.addEventListener('transitionend', schedule);
    region.addEventListener('animationend', schedule);
    window.addEventListener('resize', schedule, { passive: true });
    controllers.set(root, {
      schedule,
      destroy() {
        observer.disconnect(); cancelAnimationFrame(frame);
        region.removeEventListener('change', schedule);
        region.removeEventListener('transitionend', schedule);
        region.removeEventListener('animationend', schedule);
        window.removeEventListener('resize', schedule);
        region.querySelectorAll('[data-emp-notify-replaced]').forEach(button => button.removeAttribute('data-emp-notify-replaced'));
        region.querySelectorAll('[data-emp-notify-primary]').forEach(button => button.removeAttribute('data-emp-notify-primary'));
      }
    });
    update();
  }
  function dispose(root) {
    const controller = controllers.get(root);
    if (controller) controller.destroy();
    controllers.delete(root);
  }
  function roots(context) {
    const result = Array.from(context.querySelectorAll('[data-emp-product]'));
    if (context.matches && context.matches('[data-emp-product]')) result.unshift(context);
    return result;
  }
  function init(context) {
    controllers.forEach((controller, root) => { if (!root.isConnected) dispose(root); });
    roots(context).forEach(setup);
  }
  document.addEventListener('product:variant-change', () => {
    init(document); controllers.forEach(controller => controller.schedule());
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => roots(event.target).forEach(dispose));
  window.EmpyreumPurchaseControls = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();
